import React from 'react';
import { Search, X } from 'lucide-react';

// Refonte 2026-06-01 : la barre du haut ne porte plus QUE la recherche.
// Tous les filtres (catégorie/état/prix/marque/specs) ont migré dans la sidebar
// gauche unique (SidebarFilters), avec compteurs dynamiques par valeur.

export default function FilterBar({ filters, onChange }) {
  const handleSearch = (value) => onChange({ ...filters, search: value });

  return (
    <div data-testid="filter-bar">
      {/* Recherche mise en valeur (2026-06-01) : plus grande, icône + anneau cyan, ombre
          douce, centrée — on la repère immédiatement maintenant que la barre du haut ne
          porte plus que ça. */}
      <div className="relative max-w-3xl mx-auto">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-secondary" />
        <input
          type="text"
          placeholder="Rechercher un produit, une marque, une référence…"
          value={filters.search}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full bg-white border-2 border-slate-200 rounded-sm pl-12 pr-11 py-3.5 text-base text-primary placeholder-slate-400 shadow-sm hover:border-slate-300 focus:border-secondary focus:ring-2 focus:ring-secondary/20 focus:shadow-md outline-none transition-all"
          data-testid="filter-search"
        />
        {filters.search && (
          <button
            type="button"
            onClick={() => handleSearch('')}
            className="absolute right-3.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-secondary"
            aria-label="Effacer la recherche"
            data-testid="filter-search-clear"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
